import {useCallback, useRef} from "react";

export const useHorizontalDragScroll = () => {
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);
    const cleanupRef = useRef<(() => void) | null>(null);

    // Callback ref, not a RefObject + useEffect([]): if the target element is conditionally rendered
    // (e.g. only once async data resolves), and a callback ref is invoked by React exactly when the node
    // mounts/unmounts, so listeners always attach even when the element doesn't exist on first render.
    return useCallback((el: HTMLElement | null) => {
        cleanupRef.current?.();
        cleanupRef.current = null;

        if (!el) {
            return;
        }

        const onMouseDown = (e: MouseEvent) => {
            isDragging.current = true;
            startX.current = e.clientX;
            scrollLeft.current = el.scrollLeft;
        };

        const onMouseMove = (e: MouseEvent) => {
            if (!isDragging.current) {
                return;
            }
            el.scrollLeft = scrollLeft.current - (e.clientX - startX.current);
        };

        const onMouseUp = () => {
            isDragging.current = false;
        };

        const onTouchStart = (e: TouchEvent) => {
            startX.current = e.touches[0].clientX;
            scrollLeft.current = el.scrollLeft;
        };

        const onTouchMove = (e: TouchEvent) => {
            el.scrollLeft = scrollLeft.current - (e.touches[0].clientX - startX.current);
        };

        // mousemove/mouseup are bound to document, not el: once dragging starts it must keep tracking
        // and end correctly even if the cursor leaves the element's bounds (fast drags, taller content, etc.).
        el.addEventListener("mousedown", onMouseDown);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        el.addEventListener("touchstart", onTouchStart, {passive: true});
        el.addEventListener("touchmove", onTouchMove, {passive: true});

        cleanupRef.current = () => {
            el.removeEventListener("mousedown", onMouseDown);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
            el.removeEventListener("touchstart", onTouchStart);
            el.removeEventListener("touchmove", onTouchMove);
        };
    }, []);
};
import {useCallback, useRef} from "react";

export const useHorizontalDragScroll = () => {
    const isDragging = useRef(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);
    const cleanupRef = useRef<(() => void) | null>(null);

    // Callback ref, not a RefObject + useEffect([]): if the target element is conditionally rendered
    // (e.g. only once async data resolves), and a callback ref is invoked by React exactly when the node
    // mounts/unmounts, so listeners always attach even when the element doesn't exist on first render.
    return useCallback((el: HTMLElement | null) => {
        cleanupRef.current?.();
        cleanupRef.current = null;

        if (!el) {
            return;
        }

        const onMouseDown = (e: MouseEvent) => {
            isDragging.current = true;
            startX.current = e.clientX;
            scrollLeft.current = el.scrollLeft;
        };

        const onMouseMove = (e: MouseEvent) => {
            if (!isDragging.current) {
                return;
            }
            el.scrollLeft = scrollLeft.current - (e.clientX - startX.current);
        };

        const onMouseUp = () => {
            isDragging.current = false;
        };

        const onTouchStart = (e: TouchEvent) => {
            startX.current = e.touches[0].clientX;
            scrollLeft.current = el.scrollLeft;
        };

        const onTouchMove = (e: TouchEvent) => {
            el.scrollLeft = scrollLeft.current - (e.touches[0].clientX - startX.current);
        };

        // mousemove/mouseup are bound to document, not el: once dragging starts it must keep tracking
        // and end correctly even if the cursor leaves the element's bounds (fast drags, taller content, etc.).
        el.addEventListener("mousedown", onMouseDown);
        document.addEventListener("mousemove", onMouseMove);
        document.addEventListener("mouseup", onMouseUp);
        el.addEventListener("touchstart", onTouchStart, {passive: true});
        el.addEventListener("touchmove", onTouchMove, {passive: true});

        cleanupRef.current = () => {
            el.removeEventListener("mousedown", onMouseDown);
            document.removeEventListener("mousemove", onMouseMove);
            document.removeEventListener("mouseup", onMouseUp);
            el.removeEventListener("touchstart", onTouchStart);
            el.removeEventListener("touchmove", onTouchMove);
        };
    }, []);
};
